import { render, staticRenderFns } from "./ResumoCargasBdgdsServidorDataTable.vue?vue&type=template&id=ae1a13b4&"
import script from "./ResumoCargasBdgdsServidorDataTable.vue?vue&type=script&lang=js&"
export * from "./ResumoCargasBdgdsServidorDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
